import React, { useState, useRef } from 'react';
import './css/Nail.css';

export const Nail = () => {
    const [isPlaying, setIsPlaying] = useState(false);
    const audioRef = useRef(null);

    const togglePlay = () => {
        if (audioRef.current) {
            if (isPlaying) {
                audioRef.current.pause();
            } else {
                audioRef.current.play();
            }
            setIsPlaying(!isPlaying);
        }
    };

    return (
        <div>
            <img 
                src="./assets/images/nail.png"
                className={`peeking-character ${isPlaying ? 'playing' : ''}`}
                onClick={togglePlay}
                alt="Peeking Character"
            />
            <audio ref={audioRef} onEnded={() => setIsPlaying(false)}>
                <source src="./assets/audio/nail.wav" type="audio/wav" />
            </audio>
        </div>
    );
};
